module.exports = __webpack_public_path__ + "img/Produktbeispiel_4.c39b96c2.jpg";